module.exports = __webpack_public_path__ + "media/metronic/_theme/media/users/300_20-97ff662bfe46d62b99ad27006c5e2263.jpg";